/* eslint-disable react/prop-types */
import React from "react";
import { RotateLeft } from "@material-ui/icons";
import Button from "../../../components/CustomButtons/Button";

export default function InputDrawerReprocessButton({
  classes,
  t,
  disabled,
  onRetryProcessingButtonClick,
  downloadButtonPopperOpen,
}) {
  return (
    <Button
      color={"warning"}
      size={"sm"}
      className={classes.inputDrawerReprocessButton}
      disabled={disabled}
      onClick={onRetryProcessingButtonClick}
      aria-owns={downloadButtonPopperOpen ? "download-file-menu-list" : null}
      aria-haspopup={"true"}
    >
      <RotateLeft className={classes.inputDrawerSmallIcon} />
      {t("modeling_inputs_v2.reprocess")}
    </Button>
  );
}
